export enum LicenseType {
  User = "user",
  Server = "server",
}
